<template>
  <BasicModal
    :title="'応募者のインポート'"
    :isShowModal="isShowModal"
    :width="'80vw'"
    :canCansel="false"
    @cancel="cancel">
    <!-- 処理中モーダル -->
    <LoadingModal
      v-if="isResponseWaiting"
      :dispTitle="loadingTitle"
      :isShowModal="isResponseWaiting"
      :dispMessage="loadingMessage"
    />
    <div class="card-body">
      <div class="-bottom-8px" style="display: flex;">
        <p class="-right-8px"><b>インポート内容</b></p>
        <b-upload v-model="csvFile" accept=".csv">
          <a class="button is-small">
            <b-icon icon="upload"></b-icon>
            <span>インポートするファイルを選択</span>
          </a>
        </b-upload>
      </div>
      <!-- 試験的な実装でレイアウト調整の必要あり -->
      <!-- <div class="-bottom-8px" style="display: flex;" v-if="select_manages.length >= 1">
        <div class="-bottom-8px">
          <p><b>インポート先</b></p>
          <p class="desc">※未選択でも応募者一覧には表示されます</p>
        </div>
        <div class="-bottom-8px">
          <v-select
            v-model="selectedManage"
            :options="select_manages"
            label="name"
            :reduce="name => name.pk"
            multiple>
          </v-select>
        </div>
      </div> -->
      <p class="desc">
        <span><b>！注意</b></span>：
        既にインポートされた応募者を再度インポート行うと重複登録される可能性がございますのでCSVデータを事前にご確認の上インポートをお願い致します。
      </p>
      <p class="desc">
        更新登録の場合、アーカイブまたは削除された応募者の場合は新規応募者としてインポートされます。
      </p>
      <template v-if="importData.length > 0">
        <!-- オプション -->
        <div class="input-field">
          <p>登録方法</p>
          <b-radio v-model="allCreating"
            :native-value="0">
            全て新規データとして登録する
          </b-radio>
          <b-radio v-model="allCreating"
            :native-value="1">
            名前とEmailが既存データと一致する場合更新登録する
          </b-radio>
          <b-radio v-model="allCreating"
            :native-value="2">
            名前とTELが既存データと一致する場合更新登録する
          </b-radio>
          <b-radio v-model="allCreating"
            :native-value="3">
            名前とEmailとTELが既存データと一致する場合更新登録する
          </b-radio>
        </div>
        <!-- インポートテーブル -->
        <table class="table-box disp-scroll">
          <tr>
            <th class="table-th">
            </th>
            <th class="table-th" v-for="(h, idx) in headers" :key="'name-' + idx">
              {{getColName(idx, '')}}
            </th>
            <th class="table-th">
              {{getColName(headers.length, '')}}
            </th>
          </tr>
          <tr>
            <th class="table-th">
              1
            </th>
            <template v-for="(h, idx) in headers">
              <th class="table-th" :key="'h-' + idx">
                <p>{{h.rootName}}</p>
                <b-select
                  placeholder="設定先"
                  size="is-small"
                  v-model="h.settingsCol"
                  :id="'select-' + idx"
                  @input="isSettingCol(h.settingsCol, idx)">
                  <option
                    v-for="(col, colIdx) in companyColumnSettingFilter"
                    :key="'col-' + colIdx"
                    :value="col"
                    >
                    {{col.name}}
                  </option>
                </b-select>
              </th>
            </template>
            <th class="table-th">
              操作
            </th>
          </tr>
          <tr v-for="(d, idx) in importData" :key="idx">
            <td class="table-td" style="text-align: center;">
              {{idx + 2}}
            </td>
            <td
              class="table-td"
              v-for="(h, hIdx) in headers"
              :key="'data-' + hIdx"
              :class="{'error-color': errorColorCheck(idx, hIdx)}"
            >
              <textarea class="textarea is-small" maxlength="100" v-model="d[h.rootName]"></textarea>
            </td>
            <td class="table-td">
              <div style="display: flex;">
                <button
                @click="addRecord(idx)"
                class="button is-small is-primary -left-8px">追加</button>
                <button
                @click="delRecord(idx)"
                class="button is-small is-danger -left-8px -right-8px">削除</button>
              </div>
            </td>
          </tr>
        </table>
      </template>
      <template v-else>
        <img style="height: calc(100% - 100px); margin: auto; display: block;" src="@/assets/template/import_csv.png"/>
      </template>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="importSeeker()" :disabled="isLoading">
        <template v-if="!isLoading">追加する</template>
        <template v-else><span class="mdi mdi-loading mdi-spin"></span>読み込み中です</template>
      </button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import Encoding   from 'encoding-japanese'
// 処理中メッセージモーダル
import LoadingModal from '@/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/LoadingModal'
import {
  isMailAddress,
  isDate,
  isDateTime,
  } from '@/functions/common/checksFunc'
  import {
  convertDate,
  convertGender,
  } from '@/functions/common/convertFunc'
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  components: {
    BasicModal,
    LoadingModal,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    companyColumnSetting: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    select_manages: {
      type: Array,
      required: true
    },
    user: {
      type: Object
    },
    isResponseWaiting: {
      type: Boolean,
      required: true
    },
    loadingTitle: {
      type: String,
      required: true
    },
    loadingMessage: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      importData: [],
      headers: [],
      csvFile: null,
      allCreating: 0,
      confirmDesc: '応募者のインポートを開始してもよろしいでしょうか？',
      errorImportItem: [],
      importErrorMsg: "",
      selectedManage: [],
      addedItemList: [],
    }
  },
  created () {
    this.importData = []
    this.headers = []
    this.allCreating = 0
  },
  computed: {
    ...mapState('directtalk', ['parsedSeekerData']),
    companyColumnSettingFilter () {
      let newColumn = {
        pk: null,
        name: '新規追加',
        template_type: 0,
        order_type: null,
        is_delete: false,
        is_disabled: null,
        select: null,
        company: null,
      }
      return [newColumn, ...this.companyColumnSetting.filter((obj) => {
        // 設定できない項目は飛ばす
        // 外部情報 / アクション
        return (
             obj.template_type != 18
          && obj.template_type != 21
        )
      })]
    }
  },
  watch: {
    csvFile () {
      if (this.csvFile) {
        this.csvFileImport()
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    getColName (idx, col) {
      if (idx < 26) {
        return col + String.fromCharCode('A'.charCodeAt(0) + idx)
      } else {
        return this.getColName(
          (idx % 26),
          String.fromCharCode('A'.charCodeAt(0) + (idx / 26 - 1)))
      }
    },
    isSettingCol (obj, idx) {
      let flgCnt = 0
      this.headers.forEach((v) => {
        if (v.settingsCol) {
          if (v.settingsCol.pk != null) {
            if (v.settingsCol.pk === obj.pk) {
              flgCnt++
            }
          }
        }
      })
      if (flgCnt > 1) {
        alert('本設定先は既に設定されている項目です。他の項目を選択するか、新規追加を選択してください。')
        this.headers.splice(
          idx,
          1,
          {
            rootName: this.headers[idx].rootName,
            settingsCol: null
          })
        this.$nextTick(() => {
          let el = document.getElementById('select-' + idx)
          el.selectedIndex = -1
        })
      }
    },
    importSeeker () {
      console.log('serializeImportData: ', this.serializeImportData(this.importData))
      // バリデーションチェック
      if (this.isValidationImportData()) {
        if (confirm(this.confirmDesc)) {
          this.sendControlLog('応募者CSVインポート', '応募者のインポート画面にて、「追加する」ボタンをクリックした。')
          this.$emit('import-seeker', {
            headers: this.headers,
            dataList: this.serializeImportData(this.importData),
            flg: this.allCreating,
            selected_manage: this.selectedManage
          })
        }
      }
    },
    addErrorImportItem (row, column) {
      this.errorImportItem.push({
        "row": row,
        "column": column,
      })
    },
    resetErrorImportItem () {
      this.errorImportItem = []
    },
    addImportErrorMsg (msg) {
      this.importErrorMsg += msg
    },
    resetImportErrorMsg () {
      this.importErrorMsg = ""
    },
    getColumnNumber (templateType) {
      return this.$_.findIndex(
        this.headers,
        ((obj) => {
          return obj.settingsCol.template_type === templateType
        })
      )
    },
    isHeaderError (column) {
      let isError   = false
      this.headers.forEach((obj, row) => {        
        if (!obj.settingsCol) {
          this.addErrorImportItem(row, column)
          isError = true
        } 
      })
      return isError
    },
    isNameError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] === '') {
          this.addErrorImportItem(row, column)
          isError = true
        }
      })
      return isError
    },
    isBirthDateError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if (!isDate(obj[this.headers[column].rootName])) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isApplyDateError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if ( !isDateTime(obj[this.headers[column].rootName])
            && !isDate(obj[this.headers[column].rootName])
          ) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isSexError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if (obj[this.headers[column].rootName] != '男'
            && obj[this.headers[column].rootName] != '男性'
            && obj[this.headers[column].rootName] != '女'
            && obj[this.headers[column].rootName] != '女性'
            && obj[this.headers[column].rootName] != '選択しない'
          ) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isEmailError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          const strReturn = isMailAddress(obj[this.headers[column].rootName], 'Emailアドレス')
          if (strReturn !== '') {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isProgressRateError (column) {
      let isError = false
      let options = [
        '応募',
        '面接調整中',
        '面接',
        '採用',
        '不採用',
        '保留',
        '',
        '履歴書受付',
        'リクオプ入力済',
        '未対応',
        '対応中',
        '退社',
        '連絡済',
        '書類選考',
        '面接済',
        '内定',
        '内定辞退',
        '応募者離脱',
        '対象外',
        '入社',
        '辞退',
        '書類選考通過',
        '面接設定済',
        '面接参加無',
        '１次面接',
        '１次面接調整中',
        '１次面接設定済',
        '１次面接合格',
        '１次面接不合格',
        '２次面接',
        '２次面接調整中',
        '２次面接設定済',
        '２次面接合格',
        '２次面接不合格',
        '最終面接',
        '最終面接調整中',
        '最終面接設定済',
        '最終面接合格',
        '最終面接不合格',
        '連絡無',
        '対応済',
        '選考終了',
        'NG',
        '交渉中',
        'その他',
        'OK',
      ]
      if (this.user && this.user.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
        // 介護NEXT様向け
        options = [
          '応募', '面接調整中', '面接', '採用', '不採用', '保留', '', '履歴書受付', 'リクオプ入力済',
          '未対応', 'ヒアリング中', '連絡済み：面接日程調整中', '面接設定完了', '面接後保留',
          '採用予定', '採用', '連絡つかず不採用', '面接前：不採用', '面接前：辞退', '面接後：不採用',
          '面接後：辞退', 'FC'
        ]
      }
      else if (this.user && this.user.companyID === '812a0d58878b5d5f3897dda41b4332d7') {
        // エスケアメイト様向け
        options = [
          '応募', '面接調整中', '面接', '採用', '不採用', '保留', '', '履歴書受付', 'リクオプ入力済',
          '離脱', '辞退', '受付不可',
        ]
      }
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if (!options.includes(obj[this.headers[column].rootName])) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isApplyCountError (column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if (isNaN(obj[this.headers[column].rootName])) {
            this.addErrorImportItem(row, column)
            isError = true
          } else if (
            !Number.isInteger(
              Number(obj[this.headers[column].rootName])
            )
          ) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isArrayError(column, size) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '') {
          if (obj[this.headers[column].rootName].split('|').some((item) => item.split('#').length < size)) {
            this.addErrorImportItem(row, column)
            isError = true
          }
        }
      })
      return isError
    },
    isScoutError(column) {
      let isError = false
      this.importData.forEach((obj, row) => {
        if (obj[this.headers[column].rootName] != '' && obj[this.headers[column].rootName]!='送付済み') {
          this.addErrorImportItem(row, column)
          isError = true
        }
      })
      return isError
    },
    isValidationImportData () {
      this.resetErrorImportItem()
      this.resetImportErrorMsg()
      // ヘッダーとの紐づきチェック
      const headerColumnNumber = -1
      if (this.isHeaderError(headerColumnNumber)) {
        this.addImportErrorMsg('ヘッダーに対して、応募者管理情報への設定先を選択していない項目がございます。\n\n')
      }
      // 名前存在するか、設定先に選択しているか
      const nameColumnNumber = this.getColumnNumber(2)
      if (nameColumnNumber < 0) {
        this.addImportErrorMsg('名前を設定先に必ず選択してください。')
      } else {
        if (this.isNameError(nameColumnNumber)) {
          this.addImportErrorMsg('名前の項目に対して何も入力されていないデータがございます。1文字以上入力をお願い致します。\n\n')
        }
      }
      // 生年月日
      const birthDateColumnNumber = this.getColumnNumber(6)
      if (birthDateColumnNumber >= 0) {
        if (this.isBirthDateError(birthDateColumnNumber)) {
          this.addImportErrorMsg('生年月日が選択された列の中に生年月日以外のデータが存在しております。形式は「YYYY/MM/DD」もしくは「YYYY-MM-DD」にしてください。\n\n')
        }
      }
      // 応募日
      const applyDateColumnNumber = this.getColumnNumber(11)
      if (applyDateColumnNumber >= 0) {
        if (this.isApplyDateError(applyDateColumnNumber)) {
          this.addImportErrorMsg('応募日が選択された列の中に応募日以外のデータが存在しております。形式は「YYYY/MM/DD, YYYY/MM/DD hh:mm:ss」もしくは「YYYY-MM-DD, YYYY-MM-DD hh:mm:ss」にしてください。\n\n')
        }
      }
      // 性別
      const sexColumnNumber = this.getColumnNumber(9)
      if (sexColumnNumber >= 0) {
        if (this.isSexError(sexColumnNumber)) {
          this.addImportErrorMsg('性別が選択された列の中に性別以外のデータが存在しております。形式は「男・男性・女・女性・未設定（未入力）・選択しない」のいずれかを入力してください。\n\n')
        }
      }
      // Email
      const emailColumnNumber = this.getColumnNumber(4)
      if (emailColumnNumber >= 0) {
        if (this.isEmailError(emailColumnNumber)) {
          this.addImportErrorMsg('Emailが選択された列の中にEmail以外のデータが存在しております。@が含まれているか、ドメインが正しいかご確認のほどよろしくお願いします。\n\n')
        }
      }
      // 状況
      const progressRateColumnNumber = this.getColumnNumber(10)
      if (progressRateColumnNumber >= 0) {
        if (this.isProgressRateError(progressRateColumnNumber)) {
          this.addImportErrorMsg('状況が選択された列の中に選択肢にないデータが存在しております。選択肢にある内容かどうか確認してください。\n\n')
        }
      }
      // 応募回数
      const applyCountColumnNumber = this.getColumnNumber(12)
      if (applyCountColumnNumber >= 0) {
        if (this.isApplyCountError(applyCountColumnNumber)) {
          this.addImportErrorMsg('応募回数が選択された列の中に整数以外のデータが存在しております。値が正しいかご確認のほどよろしくお願いします。\n\n')
        }
      }
      // 配列形式(面接予定、学歴・職歴、資格)
      const interviewColumnNumber = this.getColumnNumber(22)
      if (interviewColumnNumber >= 0) {
        if (this.isArrayError(interviewColumnNumber, 4)) {
          this.addImportErrorMsg('面接予定が選択された列の中に形式の正しくないデータが存在しております。各要素を「|」で、要素内の項目を「#」で区切るようにしてください。\n\n')
        }
      }
      const careerColumnNumber = this.getColumnNumber(14)
      if (careerColumnNumber >= 0) {
        if (this.isArrayError(careerColumnNumber, 4)) {
          this.addImportErrorMsg('学歴・職歴が選択された列の中に形式の正しくないデータが存在しております。各要素を「|」で、要素内の項目を「#」で区切るようにしてください。\n\n')
        }
      }
      const qualificationColumnNumber = this.getColumnNumber(15)
      if (qualificationColumnNumber >= 0) {
        if (this.isArrayError(qualificationColumnNumber, 4)) {
          this.addImportErrorMsg('資格が選択された列の中に形式の正しくないデータが存在しております。各要素を「|」で、要素内の項目を「#」で区切るようにしてください。\n\n')
        }
      }
      // スカウト
      const scoutColumnNumber = this.getColumnNumber(16)
      if (scoutColumnNumber >= 0) {
        if (this.isScoutError(scoutColumnNumber)) {
          this.addImportErrorMsg('スカウトが選択された列の中に形式の正しくないデータが存在しております。「送付済み」もしくは空欄にしてください。')
        }
      }
      // エラー判定する。なければ処理を通す。
      if (this.errorImportItem.length || this.importErrorMsg.length) {
        alert(`以下のエラーが発生しております。修正必要箇所の背景色が黄色で表示されます。修正をよろしくお願いいたします。\n\n${this.importErrorMsg}`)
        return false
      } else {
        return true
      }
    },
    errorColorCheck (row, column) {
      let isErrorColor = false
      for (const item of this.errorImportItem) {
        if (item.row === row && item.column === column) {
          isErrorColor = true
        }
      }
      return isErrorColor
    },
    // シリアライズデータ
    serializeImportData (data) {
      let res = this.$_.cloneDeep(data)
      // 生年月日
      let index = this.$_.findIndex(
        this.headers,
        ((obj) => {
          return obj.settingsCol.template_type === 6
        })
      )
      if (index >= 0) {
        res.forEach((obj, idx) => {
          res[idx][this.headers[index].rootName] = convertDate(obj[this.headers[index].rootName])
        })
      }
      // 応募日
      index = this.$_.findIndex(
        this.headers,
        ((obj) => {
          return obj.settingsCol.template_type === 11
        })
      )
      if (index >= 0) {
        res.forEach((obj, idx) => {
          res[idx][this.headers[index].rootName] = convertDate(obj[this.headers[index].rootName])
        })
      }
      // 性別
      index = this.$_.findIndex(
        this.headers,
        ((obj) => {
          return obj.settingsCol.template_type === 9
        })
      )
      if (index >= 0) {
        res.forEach((obj, idx) => {
          res[idx][this.headers[index].rootName] = convertGender(obj[this.headers[index].rootName])
        })
      }
      // 応募回数
      index = this.$_.findIndex(
        this.headers,
        ((obj) => {
          return obj.settingsCol.template_type === 9
        })
      )
      if (index >= 0) {
        res.forEach((obj, idx) => {
          res[idx][this.headers[index].rootName] = Number(obj[this.headers[index].rootName])
        })
      }
      return res
    },
    // インポートデータ 項目追加
    addRecord (idx) {
      if (this.importData.length >= 5000) {
        alert('追加の上限値に達しました。')
        return
      }
      let addData = {}
      this.headers.forEach((v1) => {
        if(v1.settingsCol.order_type == 18) {
          addData[v1.rootName] = 1
        } else {
          addData[v1.rootName] = ''
        }
      })
      this.importData.splice(idx + 1, 0, addData)
    },
    // インポートデータ 項目削除
    delRecord (idx) {
      if (this.importData.length === 1) {
        alert('これ以上削除することはできません。')
        return
      }
      this.importData.splice(idx, 1)
    },
    // CSV インポート（検索用）
    csvFileImport () {
      this.importData = []
      this.addedItemList = []
      let reader = new FileReader()
      reader.onload = async (e) => {
        const res = new Uint8Array(e.target.result)
        const encoding = Encoding.detect(res)
        let data = Encoding.convert(res, {
          to: 'unicode',
          from: encoding,
          type: 'string'
        })
        // 旧データ対応
        data = data.replace(/,="/g, ',"')

        await this.$store.dispatch('directtalk/parseSeekerCSV', data)
        const arr = this.parsedSeekerData

        // err check
        if (arr.length === 0) {
          alert('データが存在しない、もしくは読み込みに失敗いたしました。\nカンマ区切りのCSVデータであるかご確認をお願い致します。')
        }
        if (arr.length === 1) {
          alert('データがヘッダー以外読み取れませんでした。\n1行目：ヘッダー、2行目以降にデータの記載をお願い致します。')
        }
        if (arr[0].filter((obj) => {
          return obj === ''
        }).length > 0) {
          alert('ヘッダー項目に何も記述されていないデータがございます。１行目のデータに全て項目が設定されているかご確認をお願い致します。')
        }
        // import
        // exportされた際に出力された求人ページの情報は取り込まない
        this.headers = arr[0].map((columnName) => {
          if(columnName.match(/^求人:.+/)) {
            return {
              rootName    : '',
              settingsCol : ''
            }
          } else {
            return {
              rootName    : columnName,
              settingsCol : this.setHeaderInitData(columnName)
            }
          }
        }).filter(arr => arr.rootName != '')

        // インポート画面の項目名に重複があった場合は項目名を変更する
        // ※画面の表示上のものなので実データには影響なし
        let addedColumnList = []
        this.headers.forEach((column, index) => {
          if (addedColumnList.includes(column.rootName) === true) {
            // 重複数カウント
            let count = 0
            for (const column_name of addedColumnList) {
              if (column_name == this.headers[index].rootName) {
                count++
              }
            }
            // 重複個数を含めてリネームする
            // ※既存のデータの持ち方が連想記憶配列のため、重複する項目名をキーにすると重複して格納できない
            this.headers[index].rootName = column.rootName + '(重複' + count + ')'
          }
          // 元の項目名で重複カウントしたいので、リストに追加するのは元のままの名称
          addedColumnList.push(column.rootName)
        })

        // 各項目のデータをインポート用の連想記憶配列にする
        arr.slice(1, arr.length).forEach((row) => {
          let insertArr = {}
          row.forEach((item, index) => {
            // データ数が項目数を超えたら終わり
            // ※求人データがエクスポートされている場合
            if (this.headers.length <= index) {
              return
            }
            if (this.headers[index].rootName === 'TEL') {
              item = item.replace("'", "")
            }
            insertArr[this.headers[index].rootName] = item.replace(/<indention>/g, "\r\n").replace(/\[comma\]/g, ",")
          })
          this.importData.push(insertArr)
        })
        this.csvFile = null
      }
      reader.readAsArrayBuffer(this.csvFile)
    },
    setHeaderInitData (columnName) {
      let res = ""
      // 先頭部分の空白削除（Excelからの取込時に入ってしまう？）
      const trimColumnName = columnName.trim()

      // エクスポートした応募者CSVは、デフォルトカラムが先に固まるようにしてある
      // カスタムカラムはデフォルトカラムの後ろ側に追加している
      if (this.addedItemList.includes(trimColumnName) === false) {
        // インポート項目に追加済みでなければ、デフォルトカラムから探す
        this.companyColumnSettingFilter.forEach((columnSetting) => {
          // 似たカラム名が複数存在する場合があるので完全一致で比較する
          if (columnSetting.name === trimColumnName && columnSetting.template_type > 0) {
            res = columnSetting
            this.addedItemList.push(columnSetting.name)
          }
        })
      }
      if (res === '') {
        // デフォルトカラムから見つからなければ、カスタムカラムから探す
        // カスタムカラム内で項目名が重複していても、どのデータを返すべきか判断はできない
        // なので最初に見付けたデータを返す
        this.companyColumnSettingFilter.forEach((columnSetting) => {
          // 似たカラム名が複数存在する場合があるので完全一致で比較する
          if (columnSetting.name === trimColumnName && columnSetting.template_type === 0) {
            res = columnSetting
          }
        })
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  overflow: auto;
  height: 75vh;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.input-field {
  padding: 8px;
  p {
    font-weight: 600;
    margin-bottom: 4px;
  }
}
.table-box {
  display: block;
  height: calc(75vh - 200px);
  width: 100%;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  textarea {
    border: dotted thin #ccc;
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.error-color {
  background-color: yellow;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalImportSeeker.vue